import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { RoleType } from '@/features/role/domain/enums/RoleType'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'

export class CanceledOrderFilterEntity {
  beginDate?: Date
  endDate?: Date
  cancelerRole?: RoleType
  orderBranch?: BranchMiniEntity
  orderService?: ServiceMiniEntity
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
